import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from '@angular/forms';
import {AngularFireDatabase, FirebaseObjectObservable} from 'angularfire2/database';
@Component({
  selector: 'app-view-category',
  templateUrl: './view-category.component.html',
  styleUrls: ['./view-category.component.scss']
})
export class ViewCategoryComponent {

categoryDetails:any={};
categoriesdata: FirebaseObjectObservable<any>;
  constructor(private route: ActivatedRoute,  public router: Router, public af: AngularFireDatabase) {
  	 	 	this.route.params.map(params => params['id']).subscribe((Id) => {
  	 	 	 	console.log("id" + JSON.stringify(Id));
  	 	if(Id != null) {
        this.categoriesdata = this.af.object('/categories/' + Id);
        this.categoriesdata.subscribe(
        (response) => { 
        	this.categoryDetails = response;
           console.log("response" + JSON.stringify(response))
         }
      )
          }
       });
  }

}


// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/categories/view-category/view-category.component.ts